import { atom } from 'recoil';

export const dynamicTrackingParamsState = atom<{ source_name?: string }>({
  key: 'dynamicTrackingParams',
  default: {},
});
